export const config = {
    apiKey: "AIzaSyARnfUkDNO7pLTaaCYcziI24-YoE3yVwJQ",
    authDomain: "alberts-clientapp.firebaseapp.com",
    projectId: "alberts-clientapp",
    storageBucket: "alberts-clientapp.appspot.com",
    messagingSenderId: "513281452583",
    appId: "1:513281452583:web:bca2ae0097c5981148fc02",
    measurementId: "G-MWXWV7QHWZ"
  };
